export const wait = async (t: number) =>
  new Promise((resolve) => setTimeout(resolve, t))
